(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cbx-size-picker"] && !Shopify.designMode) return;
  try {
    class CBXSizePicker extends HTMLElement {
  initialize(picker) {
    if (this.picker) return;
    const normalize = (value) => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').toLowerCase().trim();
    const sizeNames = ['grosse', 'groesse', 'size', 'taille', 'dimension', 'dimensions', 'breite', 'width', 'larghezza', 'largueur'];
    const lengthNames = ['lange', 'laenge', 'length', 'longueur', 'lunghezza'];
    const options = picker.product.options;
    const sizeIndex = options.findIndex((option) => sizeNames.includes(normalize(option.name)));
    const lengthIndex = options.findIndex((option) => lengthNames.includes(normalize(option.name)));
    if (sizeIndex < 0) return this.restoreOriginals(picker);

    const dimensions = (variant) => {
      const combined = String(variant.options[sizeIndex]).match(/^(\d+)\s*(?:cm\s*)?[x×]\s*(\d+)\s*(?:cm)?$/i);
      if (combined) return { width: Number(combined[1]), length: Number(combined[2]) };
      if (lengthIndex < 0) return null;
      const width = String(variant.options[sizeIndex]).match(/^(\d+)(?:\s*cm)?(?:\s*(?:Breite|width))?$/i);
      const length = String(variant.options[lengthIndex]).match(/^(\d+)(?:\s*cm)?(?:\s*(?:Länge|Laenge|length))?$/i);
      return width && length ? { width: Number(width[1]), length: Number(length[1]) } : null;
    };
    const variants = picker.product.variants;
    if (variants.some((variant) => !dimensions(variant))) return this.restoreOriginals(picker);

    this.picker = picker;
    this.dimensionIndexes = [sizeIndex, lengthIndex].filter((index) => index >= 0);
    this.dimensions = dimensions;
    this.select = this.querySelector('[data-size-select]');
    this.select.replaceChildren();
    const choices = new Map();
    variants.forEach((variant) => {
      const size = dimensions(variant);
      choices.set(`${size.width}x${size.length}`, size);
    });
    const sortedChoices = [...choices].sort(([, a], [, b]) => a.width - b.width || a.length - b.length);
    const hasMultipleLengths = new Set(sortedChoices.map(([, size]) => size.length)).size > 1;
    let widthGroup;
    sortedChoices.forEach(([key, size]) => {
      if (hasMultipleLengths && widthGroup?.dataset.width !== String(size.width)) {
        widthGroup = document.createElement('optgroup');
        widthGroup.dataset.width = String(size.width);
        widthGroup.label = `${this.dataset.widthLabel}: ${size.width} cm`;
        this.select.append(widthGroup);
      }
      const option = document.createElement('option');
      option.value = key;
      const label = this.dataset.productKind === 'topper'
        ? ({ '90x200': this.dataset.singleBedLabel, '180x200': this.dataset.doubleBedLabel }[key] || '')
        : (key === '90x200' ? this.dataset.standardLabel : '');
      option.dataset.label = `${size.width} × ${size.length} cm${label ? ` — ${label}` : ''}`;
      option.textContent = option.dataset.label;
      (widthGroup || this.select).append(option);
    });

    this.summary = document.createElement('div');
    this.summary.className = 'cbx-size__order-summary';
    this.summary.setAttribute('aria-live', 'polite');
    const label = document.createElement('span');
    label.textContent = this.dataset.summaryLabel;
    this.summaryValue = document.createElement('strong');
    this.summary.append(label, this.summaryValue);
    picker.masterSelector.form.querySelector('buy-buttons')?.before(this.summary);
    this.abortController = new AbortController();
    this.select.addEventListener('change', () => {
      const match = this.matchingVariants(this.select.value).find((variant) => variant.available);
      if (match) picker.selectVariant(match.id);
      this.render();
    }, { signal: this.abortController.signal });
    picker.masterSelector.form.addEventListener('variant:change', () => this.render(), { signal: this.abortController.signal });
    this.dimensionIndexes.forEach((index) => picker.optionSelectors[index].closest('fieldset').classList.add('cbx-size__original'));
    picker.classList.add('variant-picker--combined-size');
    this.hidden = false;
    this.render();
    this.select.disabled = false;
    this.removeAttribute('aria-busy');
  }

  restoreOriginals(picker) {
    picker.querySelectorAll('.cbx-size__original').forEach((fieldset) => {
      fieldset.hidden = false;
      fieldset.style.removeProperty('display');
      fieldset.classList.remove('cbx-size__original');
    });
    picker.classList.remove('variant-picker--combined-size');
    this.hidden = true;
  }

  matchingVariants(key) {
    const selected = this.picker.selectedVariant;
    return this.picker.product.variants.filter((variant) => {
      const size = this.dimensions(variant);
      return `${size.width}x${size.length}` === key && variant.options.every((value, index) => this.dimensionIndexes.includes(index) || value === selected.options[index]);
    });
  }

  render() {
    const variant = this.picker.selectedVariant;
    const size = this.dimensions(variant);
    const key = `${size.width}x${size.length}`;
    const text = `${size.width} × ${size.length} cm`;
    [...this.select.options].forEach((option) => {
      option.disabled = !this.matchingVariants(option.value).some((candidate) => candidate.available);
      option.textContent = `${option.dataset.label}${option.disabled ? ` — ${this.dataset.soldOutLabel}` : ''}`;
    });
    this.select.value = key;
    const otherOptions = variant.options.filter((value, index) => !this.dimensionIndexes.includes(index));
    this.summaryValue.textContent = [text, ...otherOptions, ...(!variant.available ? [this.dataset.soldOutLabel] : [])].join(' · ');
    document.querySelectorAll('product-sticky-bar').forEach((bar) => {
      if (bar.getAttribute('form') !== this.picker.getAttribute('form')) return;
      let summary = bar.querySelector('[data-cbx-sticky-size]');
      if (!summary) {
        summary = document.createElement('p');
        summary.dataset.cbxStickySize = '';
        summary.className = 'cbx-size__sticky-summary';
        bar.prepend(summary);
      }
      summary.textContent = this.summaryValue.textContent;
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.summary?.remove();
    this.picker = null;
  }
}

if (!customElements.get('cbx-size-picker')) customElements.define('cbx-size-picker', CBXSizePicker);
  } catch(e) { console.error(e); }
})();

})();
